/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SplitSimpleFromRocketReqApplyGoodsForSimpleVo
 */
export interface SplitSimpleFromRocketReqApplyGoodsForSimpleVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof SplitSimpleFromRocketReqApplyGoodsForSimpleVo
     */
    goodsId?: number;
    /**
     * 申请数量数量
     * @type {number}
     * @memberof SplitSimpleFromRocketReqApplyGoodsForSimpleVo
     */
    quantity?: number;
}

/**
 * Check if a given object implements the SplitSimpleFromRocketReqApplyGoodsForSimpleVo interface.
 */
export function instanceOfSplitSimpleFromRocketReqApplyGoodsForSimpleVo(value: object): value is SplitSimpleFromRocketReqApplyGoodsForSimpleVo {
    return true;
}

export function SplitSimpleFromRocketReqApplyGoodsForSimpleVoFromJSON(json: any): SplitSimpleFromRocketReqApplyGoodsForSimpleVo {
    return SplitSimpleFromRocketReqApplyGoodsForSimpleVoFromJSONTyped(json, false);
}

export function SplitSimpleFromRocketReqApplyGoodsForSimpleVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SplitSimpleFromRocketReqApplyGoodsForSimpleVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function SplitSimpleFromRocketReqApplyGoodsForSimpleVoToJSON(json: any): SplitSimpleFromRocketReqApplyGoodsForSimpleVo {
    return SplitSimpleFromRocketReqApplyGoodsForSimpleVoToJSONTyped(json, false);
}

export function SplitSimpleFromRocketReqApplyGoodsForSimpleVoToJSONTyped(value?: SplitSimpleFromRocketReqApplyGoodsForSimpleVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'quantity': value['quantity'],
    };
}

